module.exports = __webpack_public_path__ + "img/exit.7d53d058.svg";